module.exports = __webpack_public_path__ + "media/images/home/marketposter_ind_americano-ea2678f6cd01fadb4075833b5947913f.png";